<template>
    <div class="row g-1">
        <div class="col">
            <input class="form-control" v-model="currentQuery" :placeholder="$t('search.placeholder')">
        </div>
        <div class="col-1 text-end">
            <input class="btn btn-primary w-100" type="button" :disabled="!currentQuery" :value="$t('search.buttons.search')" @click.prevent="onSearch">
        </div>
        <div class="col-1 text-end">
            <input class="btn btn-secondary w-100" type="button" :disabled="!currentQuery" :value="$t('search.buttons.reset')" @click.prevent="onReset">
        </div>
    </div>
</template>

<script>
import { router } from "@inertiajs/vue3";

export default {
    name: "Search",
    props: {
        url: {
            type: String,
            required: true
        },
        query: {
            type: String
        }
    },
    data() {
        return {
            currentQuery: null
        }
    },
    methods: {
        onSearch(){
            router.get(this.url, {query: this.currentQuery}, {
                only: ['list', 'query', 'page']
            });
        },
        onReset(){
            router.get(this.url, {query: null}, {
                only: ['list', 'query', 'page']
            });
        }
    },
    mounted() {
        this.currentQuery = this.query;
    },
    update() {
        this.currentQuery = this.query;
    }
}
</script>

<style scoped>

</style>
